
import './BlogPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

function BlogPage() {
    // navigate not required here

    return (
        <div className="blog-page">
            <Header />

            {/* Hero Section */}
            <section className="blog-hero">
                <div className="blog-hero-container">
                    <h1 className="blog-hero-title">
                        Marketing Digital &amp; <span className="blog-hero-highlight">Intelligence Artificielle</span> –
                    </h1>
                    <h2 className="blog-hero-subtitle">Inspirations et conseils</h2>
                    
                    <div className="blog-hero-content">
                        <p className="blog-hero-text">
                            Une question, un projet, une idée ? Notre équipe, humaine et assistée par l'IA, est à votre écoute pour donner vie à vos ambitions digitales.
                        </p>
                        <p className="blog-hero-text">
                            Chez Viviworks.AI, chaque projet est traité avec précision grâce à l'intelligence artificielle. L'IA nous aide à anticiper vos besoins, anticiper vos performances et concevoir des stratégies sur mesure.
                        </p>
                        <p className="blog-hero-text">
                            Que vous souhaitiez développer votre visibilité en ligne, créer un site web intelligent ou booster vos campagnes marketing, nous sommes prêts à vous accompagner vers le succès.
                        </p>
                    </div>
                </div>
            </section>

            <Footer />
            <ScrollToTop />
        </div>
    );
}

export default BlogPage;

